import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_line_components_by_finished_good_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { finished_good_line_id: number }): 
  Promise<{ result: { Id?: number, ParentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_line_id)) {
      missingRequiredInParams.push('\'finished_good_line_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_line_components_by_finished_good_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { finished_good_line_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ParentId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_line_id)) {
      missingRequiredInParams.push('\'finished_good_line_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_line_components_by_finished_good_id/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { finished_good_line_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ParentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_line_id)) {
      missingRequiredInParams.push('\'finished_good_line_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_line_components_by_finished_good_id/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      finished_good_line_id: number    }) {
        if(isNil(inParams.finished_good_line_id)) {
          return true; 
        }
      return false;
    }
}
